import React from "react";
import "./companyPrimaryInfoSkeleton.css";

function CompanyPrimaryInfoSkeleton() {
  return (
    <div>
      <div className="placeholder-glow">
        <div className="baseSkeleton CompanyPrimaryInfoSkeleton-img placeholder w-100 mb-10"></div>
        <span className="baseSkeleton placeholder col-6"></span>
        <span className="baseSkeleton placeholder col-8"></span>
        <span className="baseSkeleton placeholder col-10"></span>
        <span className="baseSkeleton placeholder col-6"></span>
        <span className="baseSkeleton placeholder col-8"></span>
        <span className="baseSkeleton placeholder col-10"></span>
        <span className="baseSkeleton placeholder col-8"></span>
        <span className="baseSkeleton placeholder col-5"></span>
      </div>
      <div className="placeholder-glow d-flex mt-4">
        <span className="baseSkeleton placeholder col-3 me-2"></span>
        <span className="baseSkeleton placeholder col-3 me-2"></span>
        <span className="baseSkeleton placeholder col-4"></span>
      </div>
      <div className="placeholder-glow d-flex mt-4">
        <span className="baseSkeleton placeholder col-3 me-2"></span>
        <span className="baseSkeleton placeholder col-3 me-2"></span>
        <span className="baseSkeleton placeholder col-4"></span>
      </div>
    </div>
  );
}

export default CompanyPrimaryInfoSkeleton;
